module.exports = __webpack_public_path__ + "img/home_item_2.c6ab6034.png";